import { toCapitalizeFirstLetter } from '@loadsmart/utils-string'

import { type Load } from '../domain/Load'
import { type LoadStop } from '../domain/LoadStop'

export function getStopDescription({ city, state }: LoadStop): string {
  return `${toCapitalizeFirstLetter(city.toLowerCase())}, ${state.toUpperCase()}`
}

export function getLaneDescription({ stops }: Load) {
  const pickup = stops[0]
  const delivery = stops[stops.length - 1]
  return `${getStopDescription(pickup)} -> ${getStopDescription(delivery)}`
}
